import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function FintechServices() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.fintech-services.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/fintech-services"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/fintech-services/fintech-services.png')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection title={tp('licensing.title')} subtitle={tp('licensing.subtitle')} blocks={[{ items: obj('licensing.items') }]} />

                    <WhySection title={tp('compliance.title')} subtitle={tp('compliance.subtitle')} blocks={[{ items: obj('compliance.items') }]} />

                    <WhySection title={tp('technical.title')} subtitle={tp('technical.subtitle')} blocks={[{ items: obj('technical.items') }]} />

                    <InfoBlocks title={tp('roadmap.title')} subtitle={tp('roadmap.subtitle')} blocks={[{ items: obj('roadmap.items') }]} />

                    <ServiceCards title={tp('useCases.title')} services={obj('useCases.services')} />

                    <WhySection title={tp('topJur.title')} blocks={[{ items: obj('topJur.items') }]} />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials title={tp('testimonials.title')} testimonials={obj('testimonials.items')} />

                    <CTA title={tp('cta.title')} description={tp('cta.description')} buttonText={tp('cta.button')} buttonLink="/quote" />
                </div>
            </section>
        </main>
    );
};
